module.exports = __webpack_public_path__ + "img/arrow-bottom-left.631fa62f.png";